import {
  Box,
  Flex,
  FormControl,
  FormErrorMessage,
  Grid,
  GridItem,
  RadioGroup,
  Stack,
  Text,
} from "@chakra-ui/react";
import { Field } from "formik";
import { RadioButtonField } from "../../../../../components/RadioButtonField";
import { renderTooltip } from "../../../../../components/RenderTooltip";
import { useState } from "react";

export const ProfissionalizacaoAba = ({
  children,
  props,
  isMobile,
  placement,
}) => {
  const [hintProf, setHintProf] = useState(false);
  return (
    <>
      <Flex mb={4} justifyContent={"space-between"}>
        <Flex gap={1}>
          <Text
            fontWeight={700}
            fontSize="16px"
            lineHeight="21.6px"
            color={"#575553"}
          >
            Profissionalização{" "}
          </Text>
          {renderTooltip(
            isMobile,
            placement,
            "Ao selecionar esse filtro a pesquisa será feita em ficha de adolescentes com 16 anos ou mais.",
            hintProf,
            setHintProf,
          )}
        </Flex>

        {children}
      </Flex>

      <Box>
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={"Possui curso profissionalizante?"}
          mb={4}
          mt={7}
        >
          Possui curso profissionalizante?
        </Text>
        <Grid
          templateColumns="repeat(15, 1fr)"
          gap="15px"
          mt="15px"
          w="100%"
          alignItems={"center"}
        >
          <GridItem colSpan={{ base: 9, "2xl": 7 }}>
            <Field name="radioPossuiCurso">
              {({ field, form }) => (
                <FormControl
                  isInvalid={
                    form.errors.radioPossuiCurso &&
                    form.touched.radioPossuiCurso
                  }
                  id="radioPossuiCurso"
                  width="max-content"
                  zIndex={"1"}
                >
                  <RadioGroup
                    value={field.value}
                    onChange={(value) =>
                      props.setFieldValue("radioPossuiCurso", value)
                    }
                  >
                    <Stack direction="row" gap={4}>
                      <RadioButtonField
                        id="radio-possuiCurso-s"
                        fieldName="radioPossuiCurso"
                        value="S"
                        label="Sim"
                      />
                      <RadioButtonField
                        id="radio-possuiCurso-n"
                        fieldName="radioPossuiCurso"
                        value="N"
                        label="Não"
                      />
                    </Stack>
                  </RadioGroup>
                  <FormErrorMessage mt="-1" mr="-16">
                    {form.errors.radioPossuiCurso}
                  </FormErrorMessage>
                </FormControl>
              )}
            </Field>
          </GridItem>
        </Grid>
      </Box>
      <Box>
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={"Trabalha Atualmente?"}
          mb={4}
          mt={7}
        >
          Trabalha Atualmente?
        </Text>
        <Grid
          templateColumns="repeat(15, 1fr)"
          gap="15px"
          mt="15px"
          w="100%"
          alignItems={"center"}
        >
          <GridItem colSpan={{ base: 9, "2xl": 7 }}>
            <Field name="radioTrabalhaAtualmente">
              {({ field, form }) => (
                <FormControl
                  isInvalid={
                    form.errors.radioTrabalhaAtualmente &&
                    form.touched.radioTrabalhaAtualmente
                  }
                  id="radioTrabalhaAtualmente"
                  width="max-content"
                  zIndex={"1"}
                >
                  <RadioGroup
                    value={field.value}
                    onChange={(value) =>
                      props.setFieldValue("radioTrabalhaAtualmente", value)
                    }
                  >
                    <Stack direction="row" gap={4}>
                      <RadioButtonField
                        id="radio-trabalhaAtualmente-s"
                        fieldName="radioTrabalhaAtualmente"
                        value="S"
                        label="Sim"
                      />
                      <RadioButtonField
                        id="radio-trabalhaAtualmente-n"
                        fieldName="radioTrabalhaAtualmente"
                        value="N"
                        label="Não"
                      />
                    </Stack>
                  </RadioGroup>
                  <FormErrorMessage mt="-1" mr="-16">
                    {form.errors.radioTrabalhaAtualmente}
                  </FormErrorMessage>
                </FormControl>
              )}
            </Field>
          </GridItem>
        </Grid>
      </Box>
      <Box>
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={"Faz Estágio?"}
          mb={4}
          mt={7}
        >
          Faz Estágio?
        </Text>
        <Grid
          templateColumns="repeat(15, 1fr)"
          gap="15px"
          mt="15px"
          w="100%"
          alignItems={"center"}
        >
          <GridItem colSpan={{ base: 9, "2xl": 7 }}>
            <Field name="radioFazEstagio">
              {({ field, form }) => (
                <FormControl
                  isInvalid={
                    form.errors.radioFazEstagio && form.touched.radioFazEstagio
                  }
                  id="radioFazEstagio"
                  width="max-content"
                  zIndex={"1"}
                >
                  <RadioGroup
                    value={field.value}
                    onChange={(value) =>
                      props.setFieldValue("radioFazEstagio", value)
                    }
                  >
                    <Stack direction="row" gap={4}>
                      <RadioButtonField
                        id="radio-fazEstagio-s"
                        fieldName="radioFazEstagio"
                        value="S"
                        label="Sim"
                      />
                      <RadioButtonField
                        id="radio-fazEstagio-n"
                        fieldName="radioFazEstagio"
                        value="N"
                        label="Não"
                      />
                    </Stack>
                  </RadioGroup>
                  <FormErrorMessage mt="-1" mr="-16">
                    {form.errors.radioFazEstagio}
                  </FormErrorMessage>
                </FormControl>
              )}
            </Field>
          </GridItem>
        </Grid>
      </Box>
      <Box>
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={"Matriculado no Programa Jovem Aprendiz? "}
          mb={4}
          mt={7}
        >
          Matriculado no Programa Jovem Aprendiz?
        </Text>
        <Grid
          templateColumns="repeat(15, 1fr)"
          gap="15px"
          mt="15px"
          w="100%"
          alignItems={"center"}
        >
          <GridItem colSpan={{ base: 9, "2xl": 7 }}>
            <Field name="radioJovemAprendiz">
              {({ field, form }) => (
                <FormControl
                  isInvalid={
                    form.errors.radioJovemAprendiz &&
                    form.touched.radioJovemAprendiz
                  }
                  id="radioJovemAprendiz"
                  width="max-content"
                  zIndex={"1"}
                >
                  <RadioGroup
                    value={field.value}
                    onChange={(value) =>
                      props.setFieldValue("radioJovemAprendiz", value)
                    }
                  >
                    <Stack direction="row" gap={4}>
                      <RadioButtonField
                        id="radio-jovemAprendiz-s"
                        fieldName="radioJovemAprendiz"
                        value="S"
                        label="Sim"
                      />
                      <RadioButtonField
                        id="radio-jovemAprendiz-n"
                        fieldName="radioJovemAprendiz"
                        value="N"
                        label="Não"
                      />
                    </Stack>
                  </RadioGroup>
                  <FormErrorMessage mt="-1" mr="-16">
                    {form.errors.radioJovemAprendiz}
                  </FormErrorMessage>
                </FormControl>
              )}
            </Field>
          </GridItem>
        </Grid>
      </Box>
      <Box>
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={"Possui Currículo Vitae?"}
          mb={4}
          mt={7}
        >
          Possui Currículo Vitae?
        </Text>
        <Grid
          templateColumns="repeat(15, 1fr)"
          gap="15px"
          mt="15px"
          w="100%"
          alignItems={"center"}
        >
          <GridItem colSpan={{ base: 9, "2xl": 7 }}>
            <Field name="radioCurriculoVitae">
              {({ field, form }) => (
                <FormControl
                  isInvalid={
                    form.errors.radioCurriculoVitae &&
                    form.touched.radioCurriculoVitae
                  }
                  id="radioCurriculoVitae"
                  width="max-content"
                  zIndex={"1"}
                >
                  <RadioGroup
                    value={field.value}
                    onChange={(value) =>
                      props.setFieldValue("radioCurriculoVitae", value)
                    }
                  >
                    <Stack direction="row" gap={4}>
                      <RadioButtonField
                        id="radio-curriculoVitae-s"
                        fieldName="radioCurriculoVitae"
                        value="S"
                        label="Sim"
                      />
                      <RadioButtonField
                        id="radio-curriculoVitae-n"
                        fieldName="radioCurriculoVitae"
                        value="N"
                        label="Não"
                      />
                    </Stack>
                  </RadioGroup>
                  <FormErrorMessage mt="-1" mr="-16">
                    {form.errors.radioCurriculoVitae}
                  </FormErrorMessage>
                </FormControl>
              )}
            </Field>
          </GridItem>
        </Grid>
      </Box>
    </>
  );
};
